import React from 'react';
import type { Pressable } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { BodyText, Icon, theme, useResponsive } from '@sweetgreen/garnish';

import { useCardStyles } from './useCardStyles';

// ────────────────────────────────────────────────────────────────────────────────

type Props = {
  readonly title: string;
  readonly subtitle?: string;
  readonly palette?: 'primary' | 'secondary';
} & Pick<React.ComponentProps<typeof Pressable>, 'testID'>;

export const Callout = (props: Props) => {
  const { title, subtitle, palette = 'primary', testID } = props;
  const { fluid } = useResponsive();

  const secondary = palette === 'secondary';
  const cardStyles = useCardStyles();

  const calloutHeight = { height: fluid(74, 100) };

  return (
    <View
      style={[styles.card, calloutHeight, secondary && styles.cardSecondary]}
      testID={testID}
    >
      <View style={styles.content}>
        <BodyText
          style={[
            styles.text,
            secondary && styles.textSecondary,
            cardStyles.titleStyle,
          ]}
        >
          {title}
        </BodyText>

        {subtitle ? (
          <BodyText
            style={[
              styles.text,
              secondary && styles.textSecondary,
              cardStyles.subtitleStyle,
            ]}
          >
            {subtitle}
          </BodyText>
        ) : null}
      </View>

      <Icon
        name="IconArrowRight"
        color={secondary ? theme.colors.GREEN_1 : theme.colors.WHITE}
        width={36}
        height={36}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.radius.large,
    padding: theme.spacing.large,
  },
  content: {
    flex: 1,
  },
  text: { color: theme.colors.WHITE },
  cardSecondary: {
    borderColor: theme.colors.GREEN_2,
    borderWidth: 1,
  },
  textSecondary: {
    color: theme.colors.GREEN_1,
  },
});
